// extracted by mini-css-extract-plugin
export default {"container":"BasePageStructure_container__v64kT","headerContainer":"BasePageStructure_headerContainer__x3PIp","backButton":"BasePageStructure_backButton__pitnq"};